import {DateTime} from "luxon";


export function DateToUtc(date: DateTime, startDate = true) {
    if (startDate) {
        return date.set({hour: 0, minute: 0, second: 0}).setZone('UTC+0').toString();
    } else {
        return date.set({hour: 23, minute: 59, second: 59}).setZone('UTC+0').toString();
    }
}
